import { render, staticRenderFns } from "./VerItemCarteraAtencion.vue?vue&type=template&id=2cfe975e&scoped=true"
import script from "./VerItemCarteraAtencion.vue?vue&type=script&lang=js"
export * from "./VerItemCarteraAtencion.vue?vue&type=script&lang=js"
import style0 from "./VerItemCarteraAtencion.vue?vue&type=style&index=0&id=2cfe975e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfe975e",
  null
  
)

export default component.exports